'use client'

import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'

import { LinkType } from '@fukku/text-link/utils'
import { SelectPromotion } from 'analytics/components/SelectPromotion/SelectPromotion'
import cx from 'classix'
import type { Cta } from 'landings/Home/Home.type'
import dynamic from 'next/dynamic'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import animationStyles from '../../../../MotionAnimations.module.css'
import focusStyle from '../../../../Shared/A11y/TabFocus.module.css'
import styles from './HeroBannerShopCtas.module.css'

const ClientTextLink = dynamic(() =>
	import('@fukku/text-link/client/ClientTextLink').then(
		(mod) => mod.ClientTextLink
	)
)

interface HeroBannerShopCtasProps {
	readonly sectionCtas: Cta[]
	readonly inverse: boolean
}

export function HeroBannerShopCtas({
	sectionCtas,
	inverse,
}: HeroBannerShopCtasProps) {
	const textClassNames = cx(
		animationStyles.opacityFadeIn,
		styles.heroBannerShopCtaText,
		textHeadingM.className,
		applyStylesIf(inverse, styles.inverse)
	)

	if (sectionCtas.length === 1) {
		return <div className={textClassNames}>{sectionCtas[0].text}</div>
	}
	if (sectionCtas.length > 1) {
		return (
			<nav className={styles.heroBannerShopCtas}>
				{sectionCtas.map((cta) => (
					<SelectPromotion key={cta.ctaId} promotion={cta.promotion}>
						<ClientTextLink
							href={cta.href}
							className={cx(
								animationStyles.opacityFadeIn,
								styles.ctaLink,
								focusStyle.bannerCtaFocus
							)}
							linkProps={cta.linkProps}
							type={LinkType.Inspirational}
							inverse={inverse}
							isLocalizedPath={cta.isLocalizedPath}
							withLegacyLocale={cta.withLegacyLocale}
							data-testid='landings.home.heroBannerShopLink'
						>
							{cta.text}
						</ClientTextLink>
					</SelectPromotion>
				))}
			</nav>
		)
	}
	return null
}
